import React from 'react'
import Header from "./Header";
import { Link } from "react-router-dom";
import slot1 from "../assets/slots/Dynasty-Dynamic-BLANK-275x275 (1).png";
import slot2 from "../assets/slots/Dynasty-Dynamic-BLANK-275x275 (2).png";
import slot3 from "../assets/slots/Dynasty-Dynamic-BLANK-275x275.png";
import slot4 from "../assets/slots/Dynasty-Luna-BLANK-v2-275x275 (1).png";
import slot5 from "../assets/slots/Dynasty-Luna-BLANK-v2-275x275 (2).png";
import slot6 from "../assets/slots/Dynasty-Luna-BLANK-v2-275x275.png";
import slot7 from "../assets/slots/Dynasty-Sol-BLANK-275x275 (1).png";
import slot8 from "../assets/slots/Dynasty-Sol-BLANK-275x275 (2).png";
import slot9 from "../assets/slots/Dynasty-Sol-BLANK-275x275.png";
import slot10 from "../assets/slots/Dynasty-Sol-Sync-25-275x275 (1).png";
import slot11 from "../assets/slots/Dynasty-Sol-Sync-25-275x275 (2).png";
import slot12 from "../assets/slots/Dynasty-Sol-Sync-25-275x275.png";

function SlotsPage() {
  const slotsData = [
    { image: slot1, title: "Urban Fighter", link: "/urban-fighter" },
    { image: slot2, title: "King of the Jungle", link: "/king-of-the-jungle" },
    { image: slot3, title: "Fruit Juice", link: "/fruit-juice" },
    { image: slot4, title: "Dynasty Luna" },
    { image: slot5, title: "Dynasty Luna" },
    { image: slot6, title: "Dynasty Luna" },
    { image: slot7, title: "Dynasty Luna" },
    { image: slot8, title: "Dynasty Luna" },
    { image: slot9, title: "Dynasty Luna" },
    { image: slot10, title: "Dynasty Luna" },
    { image: slot11, title: "Dynasty Luna" },
    { image: slot12, title: "Dynasty Luna" },
  ];

  return (
    <div>
      <Header />
      <div className="lg:px-56 lg:py-28 md:px-36 md:py-20 sm:px-32 sm:py-20 py-12 px-20">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-16">
          {slotsData.map((slot, index) => (
            <div
              key={index}
              className="flex flex-col items-center bg-white relative hover:shadow-md hover:rounded-lg transition transform hover:scale-105 duration-300"
            >
              {slot.link ? (
                <Link to={slot.link} className="w-full">
                  <img src={slot.image} alt={slot.title} className="w-full object-contain h-48" />
                </Link>
              ) : (
                <div className="relative w-full">
                  <img
                    src={slot.image}
                    alt={slot.title}
                    className="w-full object-contain h-48 filter grayscale opacity-60"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="bg-black bg-opacity-50 text-white text-sm px-4 py-1 rounded-full">
                      Coming Soon
                    </span>
                  </div>
                </div>
              )}
              <h3 className="text-lg font-bold poppins-font">
                {slot.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SlotsPage;
